  import ReactDOM from "react-dom/client";
  import App from "./App";

  // Libraries
  import { BrowserRouter } from "react-router-dom";
  import { ParallaxProvider } from "react-scroll-parallax";
  import { LazyMotion, domMax } from "framer-motion";
  import { MaterialDesignContent, SnackbarProvider } from 'notistack'
  import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
  import styled from 'styled-components';

  // css
  import "./Assets/css/icons.css";
  import "./Assets/css/global.css";
  import "./Assets/css/pages.css";
  import "./index.scss";
  // Create a client
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
  const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: '#02e21d',
      color: 'white'
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: 'red',
      color: 'white'
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: 'yellow',
      color: 'white'
    },
  }));
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(

    <LazyMotion features={domMax}>
      <ParallaxProvider>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider
            Components={{
              success: StyledMaterialDesignContent,
              error: StyledMaterialDesignContent,
              warning: StyledMaterialDesignContent
            }}
            style={{ marginBottom: '50px' }}
          >
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SnackbarProvider>
        </QueryClientProvider>
      </ParallaxProvider>
    </LazyMotion>
  );
